export const DreamEvents = {};

DreamEvents.AnastasiaSexDream = () => {
    if (Yosemite.EventStateManager.anastasiaBeachFirstRequest &&
      !EventStateService.dreamAnastasiaSex) {
        return (Yosemite.Core.generateRandomNum(0, 20) === 1);
    }
}
